export default "__VITE_ASSET__BFAs3fY6__"